import { jsx as x } from "react/jsx-runtime";
import s from "react";
function b(e) {
  var o, i, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var l = e.length;
    for (o = 0; o < l; o++) e[o] && (i = b(e[o])) && (n && (n += " "), n += i);
  } else for (i in e) e[i] && (n && (n += " "), n += i);
  return n;
}
function $() {
  for (var e, o, i = 0, n = "", l = arguments.length; i < l; i++) (e = arguments[i]) && (o = b(e)) && (n && (n += " "), n += o);
  return n;
}
const k = s.createContext({
  initialAnimateComplete: !1,
  motionElements: [],
  setMotionElements: () => {
  },
  presenceMap: [],
  previousPresenceMap: []
}), D = ({
  motionKey: e,
  exitDuration: o
}) => {
  const {
    presenceMap: i,
    setMotionElements: n,
    previousPresenceMap: l,
    initialAnimateComplete: u
  } = s.useContext(k);
  return s.useEffect(() => {
    if (!(!e || !o))
      return n((m) => m.filter(
        (g) => e === g.motionKey
      ).length > 0 ? m : [...m, { motionKey: e, exitDuration: o }]), () => {
        n((m) => m.filter(
          (g) => e === g.motionKey
        ));
      };
  }, [o, e, n]), {
    presence: s.useMemo(() => {
      var r, c;
      const m = (r = i.find(
        (p) => p["tgph-motion-key"] === e
      )) == null ? void 0 : r.value, a = (c = l.find(
        (p) => p["tgph-motion-key"] === e
      )) == null ? void 0 : c.value;
      return m === a;
    }, [e, i, l]),
    initialAnimateComplete: u
  };
}, N = ({ presenceMap: e, children: o }) => {
  const [i, n] = s.useState(!1), [l, u] = s.useState(o), [f, m] = s.useState([]), [a, g] = s.useState(e);
  return s.useEffect(() => {
    const r = e;
    let c;
    if ((r == null ? void 0 : r.some(
      (h) => {
        var d;
        return h.value !== ((d = a == null ? void 0 : a.find(
          (E) => E["tgph-motion-key"] === h["tgph-motion-key"]
        )) == null ? void 0 : d.value);
      }
    )) || // Check if array has changed lengths
    (r == null ? void 0 : r.length) !== (a == null ? void 0 : a.length)) {
      const h = Math.max(
        ...f.map((d) => d.exitDuration)
      );
      c = setTimeout(() => {
        u(o), g(r);
      }, h);
    } else
      u(o), g(r);
    return () => c && clearTimeout(c);
  }, [o, f, e, a]), s.useEffect(() => {
    i || n(!0);
  }, [i]), /* @__PURE__ */ x(
    k.Provider,
    {
      value: {
        presenceMap: e,
        previousPresenceMap: a,
        initialAnimateComplete: i,
        motionElements: f,
        setMotionElements: m
      },
      children: l
    }
  );
}, C = {
  "ease-in-out": "ease-in-out",
  "ease-in": "ease-in",
  "ease-out": "ease-out",
  linear: "linear",
  spring: "linear(0, 0.25, 1)"
}, A = C["ease-in-out"], F = (e) => {
  if (!e) return A;
  const o = C == null ? void 0 : C[e];
  return o || A;
}, M = ({
  as: e,
  status: o = "initial",
  className: i,
  initial: n,
  animate: l,
  exit: u,
  transition: f,
  initializeWithAnimation: m = !0,
  style: a,
  children: g,
  "tgph-motion-key": r,
  onAnimationComplete: c,
  tgphRef: p,
  ...h
}) => {
  const d = e || "div", { presence: E, initialAnimateComplete: R } = D({
    motionKey: r || "",
    exitDuration: (f == null ? void 0 : f.duration) || 0
  }), [t, P] = s.useState(
    m === !1 && R === !1 ? l : n
  ), [y, T] = s.useState(
    m === !1 && R === !1 ? "animate" : "initial"
  );
  s.useEffect(() => {
    E === !1 && y === "animate" && T("exit");
  }, [E, y]), s.useEffect(() => {
    o === "initial" && T("animate"), o === "exit" && T("exit");
  }, [o]), s.useEffect(() => {
    let v;
    return y === "initial" && (v = setTimeout(() => {
      P(n);
    }, 10)), y === "animate" && (v = setTimeout(() => {
      P(l), c && setTimeout(() => {
        c();
      }, 10);
    }, 10)), y === "exit" && (v = setTimeout(() => {
      P(u);
    }, 10)), () => v && clearTimeout(v);
  }, [y, o, n, l, u, c]);
  const S = m === !1 && R === !1 ? 0 : f == null ? void 0 : f.duration;
  return (
    // @ts-expect-error - CSS variables inline throws a type error, but it's valid HTML.
    /* @__PURE__ */ x(
      d,
      {
        className: $("tgph-motion", i),
        style: {
          "--motion-opacity": t == null ? void 0 : t.opacity,
          "--motion-scale": t == null ? void 0 : t.scale,
          "--motion-x": typeof (t == null ? void 0 : t.x) == "number" ? `${t == null ? void 0 : t.x}px` : typeof (t == null ? void 0 : t.x) == "string" ? t == null ? void 0 : t.x : null,
          "--motion-y": typeof (t == null ? void 0 : t.y) == "number" ? `${t == null ? void 0 : t.y}px` : typeof (t == null ? void 0 : t.y) == "string" ? t == null ? void 0 : t.y : null,
          "--motion-rotate": typeof (t == null ? void 0 : t.rotate) == "number" ? `${t == null ? void 0 : t.rotate}deg` : null,
          "--motion-transition-duration": `${S}ms`,
          "--motion-transition-type": F(
            f == null ? void 0 : f.type
          ),
          ...a
        },
        ...h,
        ref: p,
        children: g
      }
    )
  );
};
M.displayName = "Motion";
const L = {
  div: s.forwardRef((e, o) => /* @__PURE__ */ x(M, { as: "div", ...e, tgphRef: o || e.tgphRef })),
  span: s.forwardRef((e, o) => /* @__PURE__ */ x(M, { as: "span", ...e, tgphRef: o || e.tgphRef })),
  button: s.forwardRef((e, o) => /* @__PURE__ */ x(M, { as: "button", ...e, tgphRef: o || e.tgphRef }))
};
export {
  N as AnimatePresence,
  M as Motion,
  L as motion
};
//# sourceMappingURL=index.mjs.map
